import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

function AddTcsMaster() {
  const navigate = useNavigate();
  const routeLocation = useLocation();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};
  const today = new Date().toISOString().split("T")[0];


  const [editId, setEditId] = useState(0);

  const [form, setForm] = useState({
    effective_date: "",
    with_pan_percentage: "",
    without_pan_percentage: ""
  });


  useEffect(() => {
    if (routeLocation.state?.routeData) {
      const data = routeLocation.state.routeData;
      setForm({
        effective_date: data.effective_date || "",
        with_pan_percentage: data.with_pan_percentage || "",
        without_pan_percentage: data.without_pan_percentage || ""
      });
      setEditId(data.tcs_master_id);
    }
  }, [routeLocation]);


  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [id]: value
    }));
  };

    const getLatestEffectiveDate = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/finance/check_effective_date`,
        { flag: "TCS" },
        { headers: { "Content-Type": "application/json" } }
      );

      return response.data?.effective_date || null;
    } catch (error) {
      console.error("Error fetching latest Effective date", error);
      return null;
    }
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  if (!form.effective_date) {
    toast.error("Effective Date is required");
    return;
  }

  if (!form.with_pan_percentage || !form.without_pan_percentage) {
    toast.error("PAN percentages are required");
    return;
  }

  // ✅ CHECK LATEST EFFECTIVE DATE (ADD MODE ONLY)
  if (!editId) {
    const latestDate = await getLatestEffectiveDate();

    if (latestDate) {
      const selectedDate = form.effective_date;        // yyyy-mm-dd
      const lastDate = latestDate.split("T")[0];       // yyyy-mm-dd

      if (selectedDate <= lastDate) {
        toast.error(
          "Please Select effective date higher than latest record"
        );
        return;
      }
    }
  }

  // ✅ Proceed with save
  const payload = {
    tcs_master_id: editId || 0,
    effective_date: form.effective_date,
    with_pan_percentage: Number(form.with_pan_percentage),
    without_pan_percentage: Number(form.without_pan_percentage),
    created_by: userObj?.user_name || "admin"
  };

  try {
    await axios.post(
      `${baseUrl}/finance/addupdatetcs_master`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    toast.success(
      editId
        ? "TCS Master Updated Successfully"
        : "TCS Master Added Successfully"
    );

    handleReset();
    navigate(".", { replace: true });
  } catch (error) {
    console.error(error.response?.data || error.message);
    toast.error("Failed to save TCS Master");
  }
};



  const handleReset = () => {
    setForm({
      effective_date: "",
      with_pan_percentage: "",
      without_pan_percentage: ""
    });
    setEditId(0);
  };

  return (
    <div className="pageBody">
      <ToastContainer />
      <Container fluid>
        <Card>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col xs={12}>
                  <h6 className="commonSectionTitle">
                    {editId ? "Edit TCS Master" : "Add TCS Master"}
                  </h6>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="commonInput">
                    <Form.Label>
                      Effective Date <span className="requiredStar">*</span>
                    </Form.Label>
                    <Form.Control
                      type="date"
                      id="effective_date"
                      value={form.effective_date}
                      onChange={handleInputChange}
                      required
                      disabled={!!editId}   // already correct
                      min={today}           // ✅ blocks past dates
                    />

                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="commonInput">
                    <Form.Label>
                      With PAN % <span className="requiredStar">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      step="0.01"
                      id="with_pan_percentage"
                      value={form.with_pan_percentage}
                      onChange={handleInputChange}
                      required
                      disabled={!!editId}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="commonInput">
                    <Form.Label>
                      Without PAN % <span className="requiredStar">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      step="0.01"
                      id="without_pan_percentage"
                      value={form.without_pan_percentage}
                      onChange={handleInputChange}
                      required
                      disabled={!!editId}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-between mt-4">
                <Button
                  type="button"
                  className="btn-info clearBtn"
                  onClick={handleReset}
                >
                  Reset
                </Button>

                <div>
                  <Button
                    type="button"
                    className="btn-danger secondaryBtn me-2"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" className="btn-success primaryBtn">
                    Submit
                  </Button>
                </div>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default AddTcsMaster;
